import { render, staticRenderFns } from "./LawLedesForm.vue?vue&type=template&id=106c81cc&"
import script from "./LawLedesForm.vue?vue&type=script&lang=js&"
export * from "./LawLedesForm.vue?vue&type=script&lang=js&"
import style0 from "./LawLedesForm.vue?vue&type=style&index=0&id=106c81cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports